import {insertScript} from '@optimaxdev/utils';

export const AMAZON_SCRIPT_SRC = 'https://static-na.payments-amazon.com/checkout.js';

/**
 * Add amazon script to body
 * @param {VoidFunctionType} callback callback
 */
export const addAmazonScript = (callback: () => void) => {
    insertScript(AMAZON_SCRIPT_SRC, false, callback);
};
